class FnbOrderQueue {}

export default FnbOrderQueue;
